import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import GoogleButton from '../components/GoogleButton';
import "./LoginNRegister.css";

export default function Login({ translations }) {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await login(email, password);
            navigate('/');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="background-modal"></div>
            <div className="content">
                <h2>{translations['login-title']}</h2>
                <input
                    type='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={translations['login-username-placeholder']}
                    className='input-text'
                />
                <input
                    type='password'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder={translations['password-placeholder']}
                    className='input-text'
                />
                {error && <p className="error-text">{error}</p>}
                <button className='btn login' onClick={handleSubmit} disabled={loading}>
                    {loading ? <span className="spinner" /> : translations['login-button']}
                </button>
                <GoogleButton translations={translations} />
                <div></div>
                <button className='btn pre-register' onClick={() => navigate("/register")}>{translations['no-account']}</button>
            </div>
        </>
    );
}
